import React, { Component } from "react";
import HeaderPrivate from "../PrivateViews/HeaderPrivate";
import MenuList from "../AdminViews/MenuList";
import Footer from "../PublicViews/Footerpersonalizado";
import { Messages } from "../../models/Messages";
import Error from "../PublicViews/Error";
import StaticPageStatus from "../SharedViews/StaticPageStatus";
import NavbarV2 from "../PublicViews/NavbarV2";
import Footerv2 from "../PublicViews/Footerv2";
import WhatsAppButton from "../PublicViews/WhatsappButton";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import { setNavbar } from "../Actions/Home_Actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

class PublicLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            open: false,
            error_message: Messages.errorTryLater,
            error_message_pop: false,
            front_modules: [],
            sectionsList: [],
            contents: [],
            contents_length: 0,
            hereYouCan: [],
            listMenu: []
        }
    }

    componentDidMount = () => {
        this.setState({ loading: true });
        this.getListMenu()
        this.getFrontModules()
    };

    getListMenu = () => {
        //it brings all the sections to be rendered 
        let url = settings.backend.listMenu;
    
        fetch(url, {
          method: "GET"
        }).then(FetchResponses.processResponse)
          .then((response) => {
            if (response) {
              this.props.setNavbar(response)
              this.setState({
                listMenu: response
              });
            }
          })
          .catch(this.failureDataResponse);
      }

    getFrontModules = () => {
        fetch(settings.backend.list_front_modules, {
          method: "GET",
          headers: settings.headers_super_auth,
        })
          .then(FetchResponses.processResponse)
          .then((response) => {
            this.setState({front_modules: response})
          })
          .catch(this.failureDataResponse);
    }
    

    handleErrorMessage = (error_message_pop = "") => {
        this.setState({ error_message_pop: error_message_pop });
    };
    
    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f2f2f2'}}>
                <WhatsAppButton />
                <NavbarV2  mainpage listMenu={this.state.listMenu}/>

                <main style={{ flex: 1, marginTop: '66px' }}>
                    {React.cloneElement(this.props.children, {
                        front_modules: this.state.front_modules
                    })}
                </main>


                <Footerv2 front_modules={this.state.front_modules}/>
            </div>
        );
    }
}
const mapStateToProps = state => ({})

export default connect(mapStateToProps, { setNavbar })(withRouter(PublicLayout))

/* export default PublicLayout; */